// display is populated in the loop below
const voices = [
  { display: 'todo', name: 'en-US-Studio-Q', gender: 'Male', type: 'Studio' },
  { display: 'todo', name: 'en-US-Studio-O', gender: 'Female', type: 'Studio' },

  { display: 'todo', name: 'en-US-Standard-A', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'en-US-Standard-B', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'en-US-Standard-D', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'en-US-Standard-C', gender: 'Female', type: 'Standard' },

  { display: 'todo', name: 'en-US-Journey-D', gender: 'Male', type: 'Journey' },
  { display: 'todo', name: 'en-US-Journey-F', gender: 'Female', type: 'Journey' },
  { display: 'todo', name: 'en-US-Journey-O', gender: 'Female', type: 'Journey' },

  { display: 'todo', name: 'es-US-Studio-B', gender: 'Male', type: 'Studio' },
  { display: 'todo', name: 'es-US-Neural2-B', gender: 'Male', type: 'Neural' },
  { display: 'todo', name: 'es-US-Neural2-C', gender: 'Male', type: 'Neural' },
  { display: 'todo', name: 'es-US-Neural2-A', gender: 'Female', type: 'Neural' },
];

const localeNames = {
  en: 'English',
  es: 'Spanish',
};

const languages = {};
for (let i = 0; i < voices.length; ++i) {
  const voice = voices[i];
  const locale = voice.name.split('-')[0];
  const type = voice.type;
  const gender = voice.gender;

  languages[locale] = languages[locale] || [];
  languages[locale][type] = languages[locale][type] || [];
  languages[locale][type][gender] = languages[locale][type][gender] || [];

  const localeName = localeNames[locale] || locale;

  const targetArray = languages[locale][type][gender];
  voice.display = `${localeName} ${voice.gender} ${voice.type} ${targetArray.length + 1}`;
  targetArray.push(voices[i]);
}

console.log(languages);
export default voices;



// WEBPACK FOOTER //
// ./src/utils/google-tts-voices.js